import { useEffect, useRef, useState } from "react";

export const useWebSocket = (url)=>{
    const wsRef = useRef(null);
    const [event, setEvent] = useState([]);
    const [connected, setConnected] = useState(false);

    const [msgList, setMsgList] = useState([]);


    const fn_setWS = async()=>{
        wsRef.current = new WebSocket(url);
        
        // 연결이 열렸을 때 호출되는 콜백 함수
        wsRef.current.onopen = () => {
            console.log('서버에 연결되었습니다.');
            setConnected(true);
        };
        
        wsRef.current.onmessage = (event) => {
            setMsgList((msgList) => [...msgList, JSON.parse(event.data)]);
        };
        
        wsRef.current.onclose = (event) => {
            console.log("연결 종료됨", event.code, event.reason);
            setConnected(false);
            setTimeout(() => fn_setWS(), 3000); 
        };
        
        wsRef.current.onError = (err) => {
            console.log("에러 : ", err);
            setConnected(false);
        };
    }

    const fn_sendWs = (msg)=>{
        wsRef.current.send(msg);
    }

    useEffect(() => {
        fn_setWS();     // 컴포넌트 마운트 시 연결

        return () => {
            if (wsRef.current) wsRef.current.close(); // 언마운트 시 연결 종료
        };
    }, [url]);

    return [fn_sendWs, msgList, connected];

}